import { FACTOR_COLORS } from "./consts";

export function getFactorColor(factor: string): string {
  return FACTOR_COLORS[factor as keyof typeof FACTOR_COLORS]?.bg || 'bg-gray-500';
}
